import { render, staticRenderFns } from "./getProp.vue?vue&type=template&id=15a3b56a"
import script from "./getProp.vue?vue&type=script&lang=js"
export * from "./getProp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/1088/89/Klettershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a3b56a')) {
      api.createRecord('15a3b56a', component.options)
    } else {
      api.reload('15a3b56a', component.options)
    }
    module.hot.accept("./getProp.vue?vue&type=template&id=15a3b56a", function () {
      api.rerender('15a3b56a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/klettershop/getProp.vue"
export default component.exports